// extracted by mini-css-extract-plugin
export var expandButton = "product-description-module--expand-button--RKPPY";
export var header = "product-description-module--header--PtQed";
export var imageRow = "product-description-module--image-row--ea8VP";
export var ratio = "product-description-module--ratio--TW0OI";
export var title = "product-description-module--title--RN2ac";